/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["custom-page{display:block;min-height:100vh;flex:1 1 auto}custom-page .page-body{padding:25px;word-break:break-all}"];
export { styles as styles };
